import { Status } from './../../../shared/enums/enums';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/app/environments/environment';
import {
  CreateMarketplaceAccountRequest,
  MarketplaceAccountLiteResponse,
  MarketplaceAccountResponse,
  PaginatedMarketplaceAccountsResponse,
} from '../../../Models/marketplaceAccountModel';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MarketplaceAccountsService {
  baseUrl: string = environment.listerApiBaseUrl;

  constructor(private http: HttpClient) {}

  getMarketplaceAccounts(
    companyId: number,
    pageNumber?: number,
    pageSize?: number,
    searchTerm?: string,
    sortCriteria?: string
  ): Observable<PaginatedMarketplaceAccountsResponse> {
    let url = `${this.baseUrl}/MarketplaceAccounts`;
    let params = new HttpParams().set('companyId', companyId.toString());

    if (pageNumber != null) {
      params = params.set('pageNumber', pageNumber.toString());
    }
    if (pageSize != null) {
      params = params.set('pageSize', pageSize.toString());
    }
    if (searchTerm?.trim()) {
      params = params.set('searchTerm', searchTerm.trim());
    }
    if (sortCriteria != null) {
      params = params.set('sortCriteria', sortCriteria.trim());
    }
    return this.http.get<PaginatedMarketplaceAccountsResponse>(url, {
      params,
    });
  }
  getMarketplaceAccountsLite(
    companyId: number,
    Marketplace: string | undefined,
  ): Observable<MarketplaceAccountLiteResponse[]> {
    let url = `${this.baseUrl}/MarketplaceAccounts/Lite`;
    const params: string[] = [];
    params.push(`status=3`);
    if (companyId !== undefined) {
      params.push(`companyId=${companyId}`);
    }
    if (Marketplace !== undefined) {
      params.push(`marketplace=${Marketplace}`);
    }
    if (params.length > 0) {
      url += '?' + params.join('&');
    }
    return this.http.get<MarketplaceAccountLiteResponse[]>(url);
  }

  getMarketplaceAccountById(id: number) {
    const url = `${this.baseUrl}/MarketplaceAccounts/${id}`;
    return this.http.get<MarketplaceAccountResponse>(url);
  }

  createMarketplaceAccount(data: CreateMarketplaceAccountRequest) {
    const url = `${this.baseUrl}/MarketplaceAccounts`;
    return this.http.post(url, data);
  }

  createBulkMarketplaceAccounts(data: CreateMarketplaceAccountRequest[]) {
    const url = `${this.baseUrl}/MarketplaceAccounts/Bulk`;
    return this.http.post(url, data);
  }

  deleteMarketplaceAccount(id: number) {
    const url = `${this.baseUrl}/MarketplaceAccounts/${id}`;
    return this.http.delete(url);
  }

  editMarketplaceAccount(id: number, data: CreateMarketplaceAccountRequest) {
    const url = `${this.baseUrl}/MarketplaceAccounts/${id}`;
    return this.http.put(url, data);
  }
}
